function injectStyle (ssrContext) {
  require("!!../../../../../node_modules/vue-official-web/node_modules/extract-text-webpack-plugin/dist/loader.js?{\"omit\":1,\"remove\":true,\"publicPath\":\"../../\"}!vue-style-loader!css-loader?{\"sourceMap\":true,\"importLoaders\":2}!../../../../../node_modules/vue-official-web/node_modules/vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-01e6cf9f\",\"scoped\":true,\"hasInlineConfig\":false}!sass-loader?{\"sourceMap\":true}!sass-resources-loader?{\"resources\":\"/data/.jenkins/jobs/ued-operation_20201027sf-wallet_vue-official-web_sfjrpc-236-56/workspace/src/components/sffui/assets/styles/index.scss\"}!../../../../../node_modules/vue-official-web/node_modules/vue-loader/lib/selector?type=styles&index=0!./HNavigation.vue")
}
var normalizeComponent = require("!../../../../../node_modules/vue-official-web/node_modules/vue-loader/lib/component-normalizer")
/* script */
export * from "!!babel-loader!../../../../../node_modules/vue-official-web/node_modules/vue-loader/lib/selector?type=script&index=0!./HNavigation.vue"
import __vue_script__ from "!!babel-loader!../../../../../node_modules/vue-official-web/node_modules/vue-loader/lib/selector?type=script&index=0!./HNavigation.vue"
/* template */
import __vue_template__ from "!!../../../../../node_modules/vue-official-web/node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-01e6cf9f\",\"hasScoped\":true,\"transformToRequire\":{\"video\":[\"src\",\"poster\"],\"source\":\"src\",\"img\":\"src\",\"image\":\"xlink:href\"},\"buble\":{\"transforms\":{}}}!../../../../../node_modules/vue-official-web/node_modules/vue-loader/lib/selector?type=template&index=0!./HNavigation.vue"
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-01e6cf9f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

export default Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/HNavigation.vue
// module id = null
// module chunks = 